<div class="app-modal">
  <app-modal-header outletName="edit" (onCloseChange)="cancel()" *ngIf="!isKIROKUKENSAKU">
    <div class="modal-header">
      <h2> 条件変更 </h2>
    </div>
  </app-modal-header>
  <div class="setting-container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-field dates">
        <span class="form-field-label">開始日</span>
        <span class="form-field-label">終了日</span>
        <app-datepicker [form]="startDate" class="inner-item" (formChange)="compareDate()"></app-datepicker>
        <app-datepicker [form]="endDate" class="inner-item" (formChange)="compareDate()"></app-datepicker>
      </div>
      <mat-error *ngIf="dateRange.hasError('compareDate')">終了日は開始日より後の日付を入力してください</mat-error>
      <ng-container *ngIf="menuConfig.isMultipleUser">
        <div class="form-field">
          <span class="form-field-label">利用者</span>
          <app-dai-search-select [form]="userForm" [placeholder]="'利用者を選択する'" [multiple]="true"
            (usersChange)="changeUserFilter($event)" [selectedId]="_daicds|| []" [arrowType]="1">
          </app-dai-search-select>
        </div>
      </ng-container>
      <!--  -->
      <div class="form-field">
        <span class="form-field-label">職員</span>
        <app-staff-search-select [form]="staffForm" [placeholder]="'職員を選択する'" [multiple]="true"
          [selectedId]="staffForm.value || []" [arrowType]="1" [selectedId]="_staffcds || []"
          (staffsChange)="changeStaffFilter($event)">
        </app-staff-search-select>
      </div>
      <!--  -->
      <div class="form-field">
        <span class="form-field-label">キーワード</span>
        <input type="text" matInput [formControl]="keyword" placeholder="キーワードを入力" />
        <p class="form-field-note">複数の場合は半角スペースで区切る</p>
      </div>
      <!--  -->
      <div class="form-field title">
        <span class="form-field-label">タイトル</span>
        <div class="form-field radio">
          <span class="form-field-label">申し送りのみ表示</span>
          <label class="switch">
            <input type="checkbox" [formControl]="pickupflg" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <!-- title select -->

      <div class="form-field">
        <mat-expansion-panel class="mat-elevation-z0 custom-kids" [expanded]="true">
          <mat-expansion-panel-header class="title-set custom">
            <div class="stuffed">記録</div>
          </mat-expansion-panel-header>
          <div class="mat-expand-body-custom">
            <div class="select-all-container">
              <mat-checkbox class="select-all" disableRipple [checked]="selectedAllKiroku || false"
                (change)="onSelectedKirokuAll()">全選択</mat-checkbox>
            </div>
            <app-record-select-item *ngFor="let filter of kirokuTagList; index as i" [titleTag]="filter"
              [form]="getForm(i, kirokuTagForm)" [selectAll]="selectedAllKiroku"></app-record-select-item>
          </div>
        </mat-expansion-panel>
      </div>

      <!-- clear btn -->
      <div class="form-field button">
        <button class="mat-button cancel" (click)="reset()" mat-button type="button">検索条件を解除する</button>
      </div>

      <app-edit-footer [isCustomClose]="true" (onCloseChange)="cancel()" cancelText="キャンセル" excuteText="検索"
        [disabled]="form.invalid"></app-edit-footer>
    </form>
  </div>
</div>